module.exports = __webpack_public_path__ + "e0d536fd71a2703c08270d8340e57b4f.png";